import {connect} from 'react-redux';
import {denormalize} from 'normalizr';

import CareGuideMembersList from '../components/CareGuideMembersList';
import {schema} from '../../../../../state/schema';
import {
  loadCareGuideMembers,
  patchCareGuideHelper,
  deleteCareGuideHelper,
  careGuideHelperShowForm,
} from '../../../../../state/modules/careGuideHelpers/actions';
import {careGuideInvitationShowForm} from '../../../../../state/modules/careGuideInvitations/actions';

const mapStateToProps = (state, ownProps) => {

  const careGuideId = ownProps.careGuideId;
  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.careGuideHelpers.getIn(['members', careGuideId, 'pages', order, limit, page]);
  const myProfileId = state.session.get('profileId');

  return {
    list: result 
      ? result.map(x => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['careGuideMembers', x]),
              schema.careGuideMember,
              state.entities.toJS()
            )
          };
        }).toArray().map(x => {

          // flatten some nested objects to make table easier to work with
          return {
            profile_name: x.profile ? x.profile.first_name + ' ' + x.profile.last_name : '',
            telephone: x.profile ? x.profile.telephone : '',
            is_self: x.profile ? myProfileId === x.profile.id : false,
            ...x
          };
        }).filter(x => x?.role !== 4 && x?.role !== 5)
      : [],
    total: state.careGuideHelpers.getIn(['results', careGuideId, 'total']),
    isLoading: state.careGuideHelpers.get('isLoading')
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (careGuideId, page, limit, order, filter, cb) => {
      dispatch(loadCareGuideMembers(careGuideId, page, limit, order, filter, cb));
    },
    patch: (careGuideId, id, data, cb) => {
      dispatch(patchCareGuideHelper(careGuideId, id, data, cb));
    },
    remove: (careGuideId, id, cb) => {
      dispatch(deleteCareGuideHelper(careGuideId, id, cb));
    },
    showForm: (helperId) => {
      dispatch(careGuideHelperShowForm(helperId));
    },
    showInvitationForm: (helperId) => {
      dispatch(careGuideInvitationShowForm(helperId));
    },
  }
}

const CareGuideMembersListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CareGuideMembersList);

export default CareGuideMembersListContainer;
